import React from "react";

import AppIcon from "src/commun/composants/AppIcon";
import { AppNestedMenu } from "fer-react-components";
import { useAppText } from "src/commun/composants/AppText";
import AppEnv from "src/app/AppEnv";
import { DictionnaireApi } from "src/app/api/DictionnaireApi";
import { useAppState } from "src/app/state/StateProvider";
import styles from "./MonCompte.scss";
import { goToUrl } from "src/app/menu/menuutil";
import { useNavigate } from "react-router-dom";

const MonCompte = () => {
  const [{ user, menu, langue }, dispatch] = useAppState();
  const { tString } = useAppText();
  const navigate = useNavigate();

  const menuItems = {
    leftIcon: <AppIcon title={tString("menu.moncompte.title")} className={"cursor-pointer couleurIconBleu"} name="menu-mon-compte" size="26px"/>,
    items: [
      {
        label: "global.bonjour",
        renderLabel: () => <>{tString("global.bonjour")}&nbsp;<span className={styles.userName}>{user?.firstName}</span></>,
        disabled: true,
        sx: {
          fontSize: "16px",
          opacity: "0.7 !important",
          marginLeft: "10px",
          marginBottom: "20px",
        },
      },
      {
        label: tString("menu.moncompte.logout"),
        callback: () => onLogout(),
        leftIcon: <AppIcon name="logout" size="26px"/>,
        bottomDivider: true,
      },
      ...(menu?.account || []).map(service => ({
        label: service.labels[langue],
        callback: () => goToUrl(service.url, service.openInNewTab, navigate),
        leftIcon: <>
          <AppIcon name={service.code} size="26px"/>
        </>,
      })),
    ],
  };

  const submitLogout = React.useRef<HTMLInputElement>(null);

  const onLogout = () => {
    if (AppEnv.typeAuth === "LDAP") {
      fetch(DictionnaireApi.logoutURL.getUrl(), { method: "POST" }).then(() => {
        dispatch({ type: "logout" });
        window.location.href = `/`;
      });
    } else {
      submitLogout.current?.click();
    }
  };

  return (
    <>
      <AppNestedMenu menuItemsData={menuItems}/>
      <form action="/logout" method="post" hidden>
        <input type="submit" value="Submit" ref={submitLogout}/>
      </form>
    </>
  );
};

export default MonCompte;
